<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  pref: Object,
})

const contents = [
  {
    id: '1',
    title: '対象ブランド',
    content: `<p>弊社が取り扱う全ブランドが対象となります。</p>`,
  },
  {
    id: '2',
    title: '保証について',
    content: `<p>並行輸入品は、いかなる場合も弊社では保証の対象外となります。<br>ご購入店様にお問い合わせいただきますようお願い申し上げます。</p>`,
  },
  {
    id: '3',
    title: '初期不良について',
    content: `<p>並行輸入品の初期不良の対応は、弊社はメーカーではございませんので行っておりません。<br>ご購入店様にお問い合わせいただきますようお願い申し上げます。</p>`,
  },
  {
    id: '4',
    title: '修理について',
    content: `<p>並行輸入品は、修理が可能な場合のみ修理を受付しております。ただし、割増料金となります。<br>また、弊社では、輸入・販売を行なっていない商品である可能性があるため、代用パーツ等での修理となる場合がございます。ご了承ください。</p>`,
  },
  {
    id: '5',
    title: '正規販売店の確認方法',
    content: `<p>以下より、正規販売店をご確認いただくことが可能でございます。<br>
      <a href="https://aandf.co.jp/stores/finder"/ >https://aandf.co.jp/stores/finder</a></p>
      <p>掲載がない店舗で正規品か確認したい場合は、以下問い合わせフォームよりお問い合わせください。<br>
      <a href="https://aandf.co.jp/contact"/ >https://aandf.co.jp/contact</a></p>`,
  },
  {
    id: '6',
    title: '最後に',
    content: `<p>並行輸入品は、正規の輸入代理店を通じて購入する場合と異なり、製品保証やアフターサービスが受けられない場合があります。また、製品の品質が悪く、仕様が異なる可能性がございます。<br>保証やアフターサービスを受けたい方は、弊社直営店及び正規販売店にてご購入をお勧めいたします。</p>`,
  },
]

onMounted(() => {
  usePref(props.pref)  
})
</script>

<template>
  
  <div class="about parallelimport">
    <Head title="並行輸入に関して" />
    <h2 class="page-title text-afgreen m-auto px-[calc(5vw_+_10px)]">
      Parallel import
      <small>並行輸入に関して</small>
    </h2>
    <div class="m-auto px-[calc(5vw_+_10px)] lg:px-0 sm:max-w-[840px] pb-[60px] sm:pb-[80px] md:pb-[100px] lg:pb-[120px]">

      <div class="text-center text-[3.5vw] xs:text-[14px] sm:text-[15px] md:text-[16px] leading-[2.2] sm:leading-[2.4] md:leading-[2.6] font-semibold mb-[50px] sm:mb-[60px] md:mb-[70px] lg:mb-[80px] break-keep">
        <p class="mb-4">弊社を通さず、別のルートで輸入されたものは<wbr />並行輸入品となります。</p>
        <p class="mb-4">通常はメーカーが認める正規輸入代理店契約に<wbr />基づいて輸入販売されることが一般的ですが、<wbr />輸入販売に関する正式の契約を<wbr />結んでいない第三者によって輸入されたものです。</p>
        <p class="mb-4">並行輸入品にも関わらず、<wbr />正規品と記載して販売している販売店が<wbr />確認されております。</p>
      </div>
      
      <div class="mb-[60px] sm:mb-[80px] md:mb-[100px] lg:mb-[120px]">
        <div class="
        flex flex-col leading-tight text-center text-[11px] xs:text-[12px] sm:text-[13px] md:text-[14px]
        [&_img]:max-h-14 [&_img]:mb-1
        [&_.row]:grid [&_.row]:grid-cols-[30vw_1fr] sm:[&_.row]:grid-cols-2 [&_.row]:gap-4 sm:[&_.row]:gap-6 md:[&_.row]:gap-8
        [&_.item]:place-content-center [&_.item]:rounded-2xl [&_.item]:h-32 [&_.item]:px-2 [&_.item]:bg-white [&_.item]:flex [&_.item]:flex-col [&_.item]:items-center
        [&_.arrow]:self-center [&_.arrow]:my-2 sm:[&_.arrow]:my-3 md:[&_.arrow]:my-4
        ">
          <div class="row !grid-cols-2 font-bold text-[14px] sm:text-[16px] md:text-[18px]">
            <div class="flex flex-col">
              <div class="item !h-20 !bg-[#0076AC] text-white">並行輸入ルート</div>
              <img class="arrow" src="/img/parallelimport/arrow_1.svg" alt="">
            </div>
            <div class="flex flex-col">
              <div class="item !h-20 !bg-afgreen text-white">正規代理店ルート</div>
              <img class="arrow" src="/img/parallelimport/arrow_2.svg" alt="">
            </div>
          </div>

          <div class="item">
            <img src="/img/parallelimport/icon_1.png" alt="海外ブランド">
            海外ブランド
          </div>

          <div class="row">
            <div class="flex flex-col">
              <img class="arrow" src="/img/parallelimport/arrow_1.svg" alt="">
              <div class="item">
                <img src="/img/parallelimport/icon_2.png" alt="海外正規代理店">
                海外正規代理店
              </div>
            </div>
            <div class="flex flex-col">
              <img class="arrow" src="/img/parallelimport/arrow_2.svg" alt="">
              <div class="item">
                <img src="/img/parallelimport/icon_5.png" alt="国内正規代理店（エイアンドエフ）">
                国内正規代理店<small>（エイアンドエフ）</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="flex flex-col">
              <img class="arrow" src="/img/parallelimport/arrow_1.svg" alt="">
              <div class="item">
                <img src="/img/parallelimport/icon_3.png" alt="並行輸入業者">
                並行輸入業者
              </div>
              <img class="arrow" src="/img/parallelimport/arrow_1.svg" alt="">
            </div>

            <div class="grid grid-cols-2 gap-2 sm:gap-3 md:gap-4">
              <div class="flex flex-col">
                <img class="arrow" src="/img/parallelimport/arrow_2.svg" alt="">
                <div class="item">
                  <img src="/img/parallelimport/icon_3.png" alt="国内販売店（エイアンドエフ卸先）">
                  国内販売店<br><small>（エイアンドエフ卸先）</small>
                </div>
                <img class="arrow" src="/img/parallelimport/arrow_2.svg" alt="">
              </div>
              <div class="flex flex-col">
                <img class="arrow" src="/img/parallelimport/arrow_2.svg" alt="">
                <div class="item">
                  <img src="/img/parallelimport/icon_6.png" alt="エイアンドエフ直営店">
                  エイアンドエフ直営店
                </div>
              <img class="arrow" src="/img/parallelimport/arrow_2.svg" alt="">
              </div>
            </div>

          </div>
          <div class="item">
            <img src="/img/parallelimport/icon_4.png" alt="お客様">
            お客様
          </div>
        </div>
      </div>
        
        <ul class="flex flex-col gap-12 sm:gap-16 md:gap-20">
          <li v-for="content in contents" :key="content.id" :id="content.id" class="flex flex-col gap-4 scroll-mt-[55px] md:scroll-mt-20">
            <h3 class="text-[17px] xs:text-[18px] sm:text-[19px] lg:text-[20px] text-afgreen pb-4 border-b border-afgreen border-dotted font-bold leading-none tracking-wide">{{ content.title }}</h3>
            <div class="flex flex-col gap-6 md:gap-8 text-[13px] sm:text-[14px] lg:text-[15px] leading-[2.4] [&_a]:underline [&_a]:text-afgreen" v-html="content.content" />
          </li>
      </ul>
      
    </div>
  </div>

</template>

